import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../components/Button';
import ContactUs from '../components/ContactUs';

import containerStyles from './HouseholdSelect.scss';
import qmStyles from '../../../theme/qmStyles';

import joinHousehold from '../assets/art-join-household.png';
import ownProperty from '../assets/art-own-property.png';
export default class HouseholdSelect extends Component {
  static propTypes = {
    navigateNext: PropTypes.func.isRequired,
  };

  render() {
    const { navigateNext } = this.props;
    return (
      <div className={containerStyles.container}>
        <div className={containerStyles.content}>
          <h3 className={containerStyles.title}>
            Looks like there’s an existing account at this address. What would
            you like to do?
          </h3>
          <div className={containerStyles.options}>
            <div>
              <div>
                <img src={joinHousehold} />
                <p>Someone in my house is already using Quartermaster</p>
              </div>
              <div style={{ width: '80%' }}>
                <Button
                  onClick={() => navigateNext({ success: true })}
                  text="Join Your Household"
                  className={containerStyles.optionButton}
                  style={{
                    backgroundColor: qmStyles.qmBabyGreen,
                    borderColor: qmStyles.qmBabyGreen,
                    color: 'white',
                  }}
                />
              </div>
            </div>
            <div>
              <div>
                <img src={ownProperty} />
                <p>I am the only person using Quartermaster at this property</p>
              </div>
              <div style={{ width: '80%' }}>
                <Button
                  onClick={() => navigateNext({ error: true })}
                  text="Start New Property"
                  style={{
                    color: qmStyles.qmBabyGreen,
                    borderColor: qmStyles.qmBabyGreen,
                  }}
                />
              </div>
            </div>
          </div>
          <ContactUs />
        </div>
      </div>
    );
  }
}
